import React, {useState} from 'react';
import EgenDropdownCSS from './dropdown.module.css';
import ProfileProductCard from '../profileMiniCards';

function EgenDokumentasjonsDropdown({ title, products }){

    const [isOpen, setIsOpen] = useState(false);

    const sortedProducts = products.slice().sort((a, b) => {
        const supplierA = a.attributes.product.data.attributes.supplier.data.attributes.name.toLowerCase();
        const supplierB = b.attributes.product.data.attributes.supplier.data.attributes.name.toLowerCase();

        return supplierA.localeCompare(supplierB);
    });


    return(
        <div className={EgenDropdownCSS.container}>
            <div className={EgenDropdownCSS.ddTrigger} onClick={()=>{setIsOpen(!isOpen)}}>
                {title}
            </div>
            <div className={`${EgenDropdownCSS.ddContent} ${isOpen ? EgenDropdownCSS.active : ''}`}>
                <div className={EgenDropdownCSS.cardDeck}>
                    {sortedProducts.map((product, index) => (
                    <ProfileProductCard 
                        key={index} 
                        product={product.attributes.product.data.attributes}
                        id={product.attributes.product.data.id} 
                    />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EgenDokumentasjonsDropdown;